import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=75da6c20&"
import script from "./EditClient.vue?vue&type=script&lang=ts&"
export * from "./EditClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports